<template>
    <BTable :items="rows" :fields="fields" striped responsive/>
    
</template>

<script>
import { BTable } from 'bootstrap-vue-next'

export default {
    name: 'reduction_winners',
    components: { BTable },
    props: {
        protocol: { type: Object, required: true },
    },
    computed: {
        rows() {
            const items = this.protocol?.reduction?.build_items || []
            let idx = 1
            return items.map(it => {
                const winner = it.history?.[0] || null
                const qty = toNum(it.quantity)
                const price = toNum(it.latest_price)
                const sum = qty * price
                
                return {
                    id: idx++,
                    winner: winner?.user_company ?? '',
                    lot: it.title ?? '',
                    qty_fmt: it.quantity_fmt ?? fmtNumber(qty),
                    price_fmt: it.latest_price_fmt ?? fmtMoney(price),
                    sum_fmt: fmtMoney(sum),
                }
            })
        },
        fields() {
            return [
                { key: 'id',       label: 'id', thStyle: { width: '56px' } },
                { key: 'winner',   label: 'Переможець' },
                { key: 'lot',      label: 'Лот' },
                { key: 'qty_fmt',  label: 'Кількість', class: 'text-end', thClass: 'text-end' },
                { key: 'price_fmt',label: 'Ціна',      class: 'text-end', thClass: 'text-end' },
                { key: 'sum_fmt',  label: 'Сума',      class: 'text-end', thClass: 'text-end' },
            ]
        },
    },
}

function toNum(v) {
    if (typeof v === 'number') return v
    if (typeof v === 'string') return Number(v.replace(',', '.')) || 0
    return 0
}
function fmtNumber(n) {
    return new Intl.NumberFormat('uk-UA', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(n)
}
function fmtMoney(n) {
    return new Intl.NumberFormat('uk-UA', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(n)
}
</script>



<style scoped>
/* легкий акцент як на твоєму стилі */
:deep(thead th) { font-weight: 600; }
</style>
